import { render } from "./Column202312.vue?vue&type=template&id=5d190862&scoped=true"
import script from "./Column202312.vue?vue&type=script&lang=js"
export * from "./Column202312.vue?vue&type=script&lang=js"

import "./Column202312.vue?vue&type=style&index=0&id=5d190862&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d190862"

export default script